import "./index.css";
import {Outlet, useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import {useRef, useState} from "react";
import Header from "../../Components/Header/Header";
import NewSideBar from "../../Components/A13/NewSideBar/NewSideBar";

export default function MainPage() {
  const offlineToastRef = useRef(null);

  const [open, setOpen] = useState(false);
  const location = useLocation();

  const title = location.state?.title !== undefined ? location.state.title : "پیشخوان";

  function updateOnlineStatus() {
    navigator.onLine
      ? toast.dismiss(offlineToastRef.current) ||
      toast.success("اتصال به شبکه اینترنت برقرار است", {
        position: "top-center",
      })
      : (offlineToastRef.current = toast.error(
        "اتصال به شبکه اینترنت را بررسی نمایید",
        {
          position: "top-center",
          autoClose: false,
        }
      ));
  }

  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);

  return (
    <>
      <div className={`main-page`}>
        <NewSideBar open={open}
                    setOpen={setOpen}/>
        <div className={"main__section"}>
          <Header
            open={open}
            setOpen={setOpen}
            title={title}
            hasLogOut={true}
          />
          <Outlet context={[open, setOpen]}/>
        </div>
      </div>
    </>
  );
}
